import type { IconSvgObject } from './types';

const MessengerIcon: IconSvgObject = [
  ["path", { d: "M7 14L10 10.5L13.5 13.5L17 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.0019 22.002C17.5259 22.002 22.0039 17.5239 22.0039 12C22.0039 6.47607 17.5259 1.99805 12.0019 1.99805C6.47802 1.99805 2 6.47607 2 12C2 13.8889 2.43396 15.4979 3.34399 17.005L2.00451 21.9852C2.00251 21.9926 2.00932 21.9995 2.01676 21.9974L6.97239 20.666C8.48539 21.5862 10.1017 22.002 12.0019 22.002Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MessengerIcon;
